import { render, staticRenderFns } from "./CategoriesNew.vue?vue&type=template&id=0b5218e8&scoped=true&"
import script from "./CategoriesNew.vue?vue&type=script&lang=js&"
export * from "./CategoriesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5218e8",
  null
  
)

export default component.exports